import './styles.scss';
export const Logo = (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    // fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='logo'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20 36.8421C29.3016 36.8421 36.8421 29.3016 36.8421 20C36.8421 10.6984 29.3016 3.15789 20 3.15789C10.6984 3.15789 3.15789 10.6984 3.15789 20C3.15789 29.3016 10.6984 36.8421 20 36.8421ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z'
      // fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19.9998 33.6841C27.5574 33.6841 33.684 27.5575 33.684 19.9999C33.684 12.4423 27.5574 6.31571 19.9998 6.31571C12.4422 6.31571 6.31559 12.4423 6.31559 19.9999C6.31559 27.5575 12.4422 33.6841 19.9998 33.6841ZM19.9998 35.7894C28.7201 35.7894 35.7893 28.7202 35.7893 19.9999C35.7893 11.2796 28.7201 4.21045 19.9998 4.21045C11.2795 4.21045 4.21033 11.2796 4.21033 19.9999C4.21033 28.7202 11.2795 35.7894 19.9998 35.7894Z'
      // fill='#F7F7F7'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20.0003 31.5789C26.3952 31.5789 31.5792 26.3948 31.5792 19.9999C31.5792 13.6051 26.3952 8.42099 20.0003 8.42099C13.6054 8.42099 8.42135 13.6051 8.42135 19.9999C8.42135 26.3948 13.6054 31.5789 20.0003 31.5789ZM20.0003 33.1578C27.2672 33.1578 33.1582 27.2668 33.1582 19.9999C33.1582 12.733 27.2672 6.84204 20.0003 6.84204C12.7334 6.84204 6.84241 12.733 6.84241 19.9999C6.84241 27.2668 12.7334 33.1578 20.0003 33.1578Z'
      // fill='#F8F8F8'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19.9999 29.4736C25.2321 29.4736 29.4736 25.2321 29.4736 19.9999C29.4736 14.7678 25.2321 10.5263 19.9999 10.5263C14.7678 10.5263 10.5263 14.7678 10.5263 19.9999C10.5263 25.2321 14.7678 29.4736 19.9999 29.4736ZM19.9999 30.5263C25.8135 30.5263 30.5263 25.8135 30.5263 19.9999C30.5263 14.1864 25.8135 9.47363 19.9999 9.47363C14.1864 9.47363 9.47363 14.1864 9.47363 19.9999C9.47363 25.8135 14.1864 30.5263 19.9999 30.5263Z'
      // fill='#FAF9F9'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20.0005 27.1052C23.9246 27.1052 27.1057 23.9241 27.1057 20C27.1057 16.0758 23.9246 12.8947 20.0005 12.8947C16.0763 12.8947 12.8952 16.0758 12.8952 20C12.8952 23.9241 16.0763 27.1052 20.0005 27.1052ZM20.0005 27.8947C24.3606 27.8947 27.8952 24.3601 27.8952 20C27.8952 15.6398 24.3606 12.1052 20.0005 12.1052C15.6403 12.1052 12.1057 15.6398 12.1057 20C12.1057 24.3601 15.6403 27.8947 20.0005 27.8947Z'
      // fill='#FBFBFB'
    />
    <path
      d='M25.2631 20C25.2631 22.9067 22.9067 25.2631 20 25.2631C17.0932 25.2631 14.7368 22.9067 14.7368 20C14.7368 17.0932 17.0932 14.7368 20 14.7368C22.9067 14.7368 25.2631 17.0932 25.2631 20Z'
      // fill='white'
    />
    <path
      d='M22.6321 20C22.6321 21.4534 21.4539 22.6316 20.0005 22.6316C18.5471 22.6316 17.3689 21.4534 17.3689 20C17.3689 18.5466 18.5471 17.3684 20.0005 17.3684C21.4539 17.3684 22.6321 18.5466 22.6321 20Z'
      // fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20.0005 22.1053C21.1632 22.1053 22.1057 21.1627 22.1057 20C22.1057 18.8373 21.1632 17.8947 20.0005 17.8947C18.8378 17.8947 17.8952 18.8373 17.8952 20C17.8952 21.1627 18.8378 22.1053 20.0005 22.1053ZM20.0005 22.6316C21.4539 22.6316 22.6321 21.4534 22.6321 20C22.6321 18.5466 21.4539 17.3684 20.0005 17.3684C18.5471 17.3684 17.3689 18.5466 17.3689 20C17.3689 21.4534 18.5471 22.6316 20.0005 22.6316Z'
      // fill='white'
    />
  </svg>
);

export const Head_icon = (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15 2.30769C7.99023 2.30769 2.30769 7.99023 2.30769 15C2.30769 22.0098 7.99023 27.6923 15 27.6923C22.0098 27.6923 27.6923 22.0098 27.6923 15C27.6923 7.99023 22.0098 2.30769 15 2.30769ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z'
      fill='#474747'
    />
    <path
      d='M9.80769 13.8462C10.7636 13.8462 11.5385 13.0713 11.5385 12.1154C11.5385 11.1595 10.7636 10.3846 9.80769 10.3846C8.85181 10.3846 8.07692 11.1595 8.07692 12.1154C8.07692 13.0713 8.85181 13.8462 9.80769 13.8462Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M17.3077 12.1154C17.3077 11.4781 17.8243 10.9615 18.4615 10.9615H21.9231C22.5603 10.9615 23.0769 11.4781 23.0769 12.1154C23.0769 12.7526 22.5603 13.2692 21.9231 13.2692H18.4615C17.8243 13.2692 17.3077 12.7526 17.3077 12.1154Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.42073 17.4635C8.97186 17.1436 9.67798 17.3311 9.99789 17.8822C10.5064 18.7583 11.2361 19.4855 12.1139 19.9909C12.9918 20.4964 13.987 20.7624 15 20.7624C16.0129 20.7624 17.0081 20.4964 17.886 19.9909C18.7638 19.4855 19.4935 18.7583 20.002 17.8822C20.3219 17.3311 21.0281 17.1436 21.5792 17.4635C22.1303 17.7834 22.3178 18.4895 21.9979 19.0407C21.2865 20.2663 20.2656 21.2836 19.0375 21.9908C17.8094 22.6979 16.4171 23.0701 15 23.0701C13.5828 23.0701 12.1905 22.6979 10.9624 21.9908C9.7343 21.2836 8.71346 20.2663 8.00204 19.0407C7.68214 18.4895 7.86959 17.7834 8.42073 17.4635Z'
      fill='#474747'
    />
  </svg>
);

export const Car_icon = (
  <svg
    width='30'
    height='26'
    viewBox='0 0 30 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M29 12.0001H27.58L24.1562 6.00631C23.8025 5.38256 23.1413 5.00006 22.4237 5.00006H19.6763L18.18 1.25756C17.8813 0.500057 17.13 -0.00619278 16.325 5.7224e-05H13.6687C12.8587 5.7224e-05 12.1175 0.503807 11.8212 1.25381L10.3225 5.00006H7.57125C6.8575 5.00006 6.195 5.38506 5.84375 6.00381L2.41875 12.0001H1C0.4475 12.0001 0 12.4476 0 13.0001C0 13.5526 0.4475 14.0001 1 14.0001H2V24.0001C2 25.1026 2.8975 26.0001 4 26.0001H7C8.1025 26.0001 9 25.1026 9 24.0001V22.0001H21V24.0001C21 25.1026 21.8975 26.0001 23 26.0001H26C27.1025 26.0001 28 25.1026 28 24.0001V14.0001H29C29.5525 14.0001 30 13.5526 30 13.0001C30 12.4476 29.5525 12.0001 29 12.0001ZM13.6775 2.00006H16.3237L17.5238 5.00006H12.4775L13.6775 2.00006ZM7.57875 7.00006H22.4212L25.2775 12.0001H4.7225L7.57875 7.00006ZM7 24.0001H4V22.0001H7V24.0001ZM23 24.0001V22.0001H26V24.0001H23ZM26 20.0001H4V14.0001H26V20.0001Z'
      fill='#474747'
    />
    <path
      d='M7 18.0001H9C9.5525 18.0001 10 17.5526 10 17.0001C10 16.4476 9.5525 16.0001 9 16.0001H7C6.4475 16.0001 6 16.4476 6 17.0001C6 17.5526 6.4475 18.0001 7 18.0001Z'
      fill='#474747'
    />
    <path
      d='M21 18.0001H23C23.5525 18.0001 24 17.5526 24 17.0001C24 16.4476 23.5525 16.0001 23 16.0001H21C20.4475 16.0001 20 16.4476 20 17.0001C20 17.5526 20.4475 18.0001 21 18.0001Z'
      fill='#474747'
    />
  </svg>
);

export const Clock_icon = (
  <svg
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15 2.30769C7.99023 2.30769 2.30769 7.99023 2.30769 15C2.30769 22.0098 7.99023 27.6923 15 27.6923C22.0098 27.6923 27.6923 22.0098 27.6923 15C27.6923 7.99023 22.0098 2.30769 15 2.30769ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M15 5.76923C15.6373 5.76923 16.1538 6.28583 16.1538 6.92308V13.8462H23.0769C23.7142 13.8462 24.2308 14.3627 24.2308 15C24.2308 15.6373 23.7142 16.1538 23.0769 16.1538H15C14.3627 16.1538 13.8462 15.6373 13.8462 15V6.92308C13.8462 6.28583 14.3627 5.76923 15 5.76923Z'
      fill='#474747'
    />
  </svg>
);

export const Vector_underline = (
  <svg
    width='195'
    height='24'
    viewBox='0 0 195 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 17.2292C37.6218 17.2292 71.6882 11.1181 106.07 7.77739C133.113 5.14975 214.706 5.07687 187.536 5.07687C129.338 5.07687 56.6638 -5.55189 3 21.28'
      stroke='#34AC46'
      stroke-width='4.06763'
      stroke-linecap='round'
    />
  </svg>
);

export const Vector_underline_2 = (
  <svg
    width='115'
    height='16'
    viewBox='0 0 115 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 11.238C23.0442 11.238 42.7668 7.69997 62.6721 5.76586C78.3284 4.24459 125.567 4.2024 109.836 4.2024C76.1428 4.2024 34.0685 -1.9511 3 13.5832'
      stroke='#316E4D'
      stroke-width='4.06763'
      stroke-linecap='round'
    />
  </svg>
);

export const Vector_underline_3 = (
  <svg
    width='145'
    height='17'
    viewBox='0 0 145 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 11.5624C28.5108 11.5624 53.6123 7.88509 78.9462 5.8748C98.8725 4.29361 158.994 4.24976 138.974 4.24976C96.0908 4.24976 42.5417 -2.14611 3 14'
      stroke='#316E4D'
      stroke-width='4.06763'
      stroke-linecap='round'
    />
  </svg>
);

export const Arrow = (
  <svg
    width='25'
    height='16'
    viewBox='0 0 25 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ position: 'relative', top: '5px' }}
  >
    <path
      d='M23.7326 8.45711C24.1231 8.06658 24.1231 7.43342 23.7326 7.04289L17.3687 0.678932C16.9781 0.288408 16.345 0.288408 15.9544 0.678932C15.5639 1.06946 15.5639 1.70262 15.9544 2.09315L21.6113 7.75L15.9544 13.4069C15.5639 13.7974 15.5639 14.4305 15.9544 14.8211C16.345 15.2116 16.9781 15.2116 17.3687 14.8211L23.7326 8.45711ZM0.899414 8.75H23.0255V6.75H0.899414V8.75Z'
      fill='#232129'
    />
  </svg>
);

export const backLayer = (
  <svg
    width='176'
    height='199'
    viewBox='0 0 176 199'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M169.155 111.141C171.337 122.858 178.08 134.779 174.068 146.012C169.968 157.489 157.339 165.484 146.712 173.967C134.989 183.326 125.344 198.172 108.162 198.627C89.8284 199.112 74.9372 185.781 60.8613 176.24C50.1758 168.997 49.821 152.658 36.2112 149.857C12.0836 144.893 -13.89 164.939 -36.3412 156.238C-53.2007 149.705 -59.465 128.494 -53.0401 115.271C-45.3812 99.5095 -3.16754 102.149 -1.80882 85.1718C0.0519374 61.9218 -50.8137 46.1676 -45.6803 23.312C-41.9895 6.87942 -6.28567 6.03622 15.3686 8.69237C37.8403 11.4488 49.9401 39.4341 72.3658 37.7918C98.0351 35.9119 103.965 -0.229096 129.866 0.307239C150.317 0.730716 158.568 24.467 164.593 39.7015C170.045 53.4863 161.209 67.6 162.119 81.859C162.756 91.8302 167.308 101.222 169.155 111.141Z'
      fill='#FCFAF8'
    />
  </svg>
);

export const partner_pack_icon = (
  <svg
    width='23'
    height='20'
    viewBox='0 0 31 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M10 2C6.96243 2 4.5 4.46243 4.5 7.5C4.5 10.5376 6.96243 13 10 13C13.0376 13 15.5 10.5376 15.5 7.5C15.5 4.46243 13.0376 2 10 2ZM2.5 7.5C2.5 3.35786 5.85786 0 10 0C14.1421 0 17.5 3.35786 17.5 7.5C17.5 11.6421 14.1421 15 10 15C5.85786 15 2.5 11.6421 2.5 7.5Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20.1845 9.29832e-06L20.1876 0C22.1767 4.64916e-06 24.0843 0.790181 25.4909 2.1967C26.8974 3.60323 27.6876 5.51088 27.6876 7.5C27.6876 9.48913 26.8974 11.3968 25.4909 12.8033C24.0843 14.2098 22.1767 15 20.1876 15C19.6353 15 19.1876 14.5523 19.1876 14C19.1876 13.4477 19.6353 13 20.1876 13C21.6462 13 23.0452 12.4205 24.0766 11.3891C25.1081 10.3576 25.6876 8.95869 25.6876 7.5C25.6876 6.04131 25.1081 4.64237 24.0766 3.61092C23.0455 2.57982 21.6472 2.00041 20.1891 2C19.6816 2.00168 19.1766 2.06981 18.6868 2.20264C18.1538 2.3472 17.6045 2.03229 17.4599 1.49926C17.3154 0.966237 17.6303 0.416938 18.1633 0.272372C18.8222 0.0936556 19.5018 0.00208789 20.1845 9.29832e-06Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M10 15C8.39525 15 6.81415 15.3857 5.39009 16.1255C3.96604 16.8653 2.74093 17.9369 1.81827 19.2499C1.50072 19.7018 0.876994 19.8107 0.425125 19.4931C-0.0267446 19.1756 -0.135639 18.5519 0.181902 18.1C1.2891 16.5244 2.75923 15.2385 4.46809 14.3507C6.17696 13.463 8.0743 13 10 13C11.9257 13 13.8232 13.463 15.5321 14.3507C17.2409 15.2385 18.7111 16.5244 19.8183 18.1C20.1358 18.5519 20.0269 19.1756 19.575 19.4931C19.1232 19.8107 18.4994 19.7018 18.1819 19.2499C17.2592 17.9369 16.0341 16.8653 14.6101 16.1255C13.186 15.3857 11.6048 15 10 15Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M24.7982 16.1244C23.3741 15.3847 21.7923 14.999 20.1876 15C19.6353 15 19.1876 14.5523 19.1876 14C19.1876 13.4477 19.6353 13 20.1876 13C22.1136 12.9988 24.0109 13.4617 25.7201 14.3496C27.4293 15.2374 28.8994 16.524 30.006 18.1005C30.3233 18.5525 30.2141 19.1762 29.762 19.4935C29.31 19.8108 28.6863 19.7016 28.369 19.2495C27.4471 17.9361 26.2222 16.8641 24.7982 16.1244Z'
      fill='#474747'
    />
  </svg>
);

export const family_pack_icon = (
  <svg
    width='23'
    height='20'
    viewBox='0 0 32 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M16 8.5C13.7909 8.5 12 10.2909 12 12.5C12 14.7091 13.7909 16.5 16 16.5C18.2091 16.5 20 14.7091 20 12.5C20 10.2909 18.2091 8.5 16 8.5ZM10 12.5C10 9.18629 12.6863 6.5 16 6.5C19.3137 6.5 22 9.18629 22 12.5C22 15.8137 19.3137 18.5 16 18.5C12.6863 18.5 10 15.8137 10 12.5Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M27.4082 11.1836C26.5058 10.7324 25.5105 10.4983 24.5017 10.5C23.9494 10.5009 23.5009 10.054 23.5 9.50168C23.4991 8.9494 23.946 8.50094 24.4983 8.50001C25.8188 8.4978 27.1216 8.80419 28.3026 9.39473C29.4837 9.98527 30.5105 10.8436 31.301 11.9014C31.6316 12.3437 31.541 12.9704 31.0987 13.301C30.6563 13.6316 30.0296 13.5411 29.699 13.0987C29.095 12.2906 28.3106 11.6348 27.4082 11.1836Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7.49839 10.5C6.48952 10.4983 5.49421 10.7324 4.59185 11.1836C3.68948 11.6348 2.90503 12.2906 2.30106 13.0987C1.97043 13.5411 1.34378 13.6316 0.901399 13.301C0.459018 12.9704 0.368426 12.3437 0.699058 11.9014C1.48958 10.8436 2.51634 9.98527 3.69742 9.39473C4.8785 8.80419 6.18124 8.4978 7.50173 8.50001C8.05402 8.50094 8.50098 8.9494 8.50006 9.50168C8.49914 10.054 8.05067 10.5009 7.49839 10.5Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M16 18.5032C14.6865 18.5032 13.3994 18.8721 12.2853 19.5679C11.1712 20.2637 10.275 21.2584 9.69863 22.4388C9.4563 22.935 8.85753 23.1409 8.36125 22.8986C7.86497 22.6562 7.6591 22.0575 7.90143 21.5612C8.64215 20.0442 9.79403 18.7658 11.2259 17.8716C12.6577 16.9773 14.3119 16.5032 16 16.5032C17.6882 16.5032 19.3424 16.9773 20.7742 17.8716C22.206 18.7658 23.3579 20.0442 24.0986 21.5612C24.341 22.0575 24.1351 22.6562 23.6388 22.8986C23.1425 23.1409 22.5438 22.935 22.3014 22.4388C21.7251 21.2584 20.8288 20.2637 19.7147 19.5679C18.6007 18.8721 17.3135 18.5032 16 18.5032Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M8.24117 2.59399C7.68961 2.45258 7.10919 2.47105 6.56774 2.64725C6.02629 2.82346 5.54617 3.15011 5.18347 3.58904C4.82077 4.02798 4.59048 4.56107 4.5195 5.12602C4.44852 5.69098 4.53978 6.26447 4.78263 6.77949C5.02547 7.2945 5.40987 7.72977 5.8909 8.03443C6.37194 8.3391 6.92974 8.50058 7.49914 8.5C8.05142 8.49944 8.49959 8.9467 8.50015 9.49898C8.50072 10.0513 8.05345 10.4994 7.50117 10.5C6.55217 10.501 5.6225 10.2318 4.82078 9.72406C4.01905 9.21628 3.37839 8.49083 2.97365 7.63248C2.5689 6.77412 2.4168 5.8183 2.5351 4.8767C2.6534 3.93511 3.03722 3.04663 3.64172 2.31507C4.24622 1.58351 5.04643 1.03909 5.94884 0.745423C6.85126 0.451755 7.81861 0.420967 8.73788 0.656656C9.65714 0.892345 10.4903 1.38478 11.1401 2.07642C11.7899 2.76805 12.2295 3.63033 12.4074 4.5625C12.511 5.10499 12.1551 5.62871 11.6127 5.73226C11.0702 5.83582 10.5464 5.47999 10.4429 4.9375C10.3361 4.3782 10.0724 3.86083 9.68252 3.44585C9.29265 3.03087 8.79272 2.73541 8.24117 2.59399Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M25.4323 2.64725C24.8909 2.47105 24.3104 2.45258 23.7589 2.59399C23.2073 2.73541 22.7074 3.03087 22.3175 3.44585C21.9276 3.86083 21.6639 4.3782 21.5572 4.9375C21.4536 5.47999 20.9299 5.83582 20.3874 5.73226C19.8449 5.62871 19.4891 5.10499 19.5926 4.5625C19.7706 3.63033 20.2101 2.76805 20.8599 2.07642C21.5097 1.38478 22.3429 0.892345 23.2622 0.656656C24.1814 0.420967 25.1488 0.451755 26.0512 0.745423C26.9536 1.03909 27.7538 1.58351 28.3583 2.31507C28.9628 3.04663 29.3466 3.93511 29.4649 4.8767C29.5832 5.8183 29.4311 6.77412 29.0264 7.63248C28.6217 8.49083 27.981 9.21628 27.1793 9.72406C26.3775 10.2318 25.4479 10.501 24.4989 10.5C23.9466 10.4994 23.4993 10.0513 23.4999 9.49898C23.5005 8.9467 23.9486 8.49944 24.5009 8.5C25.0703 8.50058 25.6281 8.3391 26.1091 8.03443C26.5902 7.72977 26.9746 7.2945 27.2174 6.77949C27.4603 6.26447 27.5515 5.69098 27.4805 5.12602C27.4096 4.56107 27.1793 4.02798 26.8166 3.58904C26.4539 3.15011 25.9738 2.82346 25.4323 2.64725Z'
      fill='#474747'
    />
  </svg>
);

export const customize_pack_icon = (
  <svg
    width='23'
    height='20'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.8248 3.43555H4.3307C3.44734 3.43555 2.60016 3.78646 1.97554 4.41109C1.35091 5.03571 1 5.88289 1 6.76624V21.7544C1 22.6377 1.35091 23.4849 1.97554 24.1095C2.60016 24.7342 3.44734 25.0851 4.3307 25.0851H20.9842C21.8675 25.0851 22.7147 24.7342 23.3393 24.1095C23.964 23.4849 24.3149 22.6377 24.3149 21.7544V14.2603'
      stroke='black'
      stroke-width='1.8'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
    <path
      d='M20.9845 5.10095L22.5716 6.76629M24.3152 1.71529C24.7592 2.17436 25.005 2.78947 24.9997 3.42807C24.9944 4.06667 24.7384 4.67762 24.2869 5.12926L12.6578 16.7584L7.66174 18.4237L9.32709 13.4277L20.9629 1.69364C21.3719 1.28143 21.9193 1.03556 22.4992 1.00357C23.079 0.971574 23.6501 1.15574 24.1021 1.52045L24.3152 1.71529Z'
      stroke='black'
      stroke-width='1.8'
      stroke-linecap='round'
      stroke-linejoin='round'
    />
  </svg>
);

export const party_pack_icon = (
  <svg
    width='23'
    height='20'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7 15C5.34315 15 4 16.3431 4 18C4 19.6569 5.34315 21 7 21C8.65685 21 10 19.6569 10 18C10 16.3431 8.65685 15 7 15ZM2 18C2 15.2386 4.23858 13 7 13C9.76142 13 12 15.2386 12 18C12 20.7614 9.76142 23 7 23C4.23858 23 2 20.7614 2 18Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7 23C5.99091 23 4.99573 23.2349 4.09317 23.6862C3.19061 24.1375 2.40551 24.7927 1.80006 25.6C1.46869 26.0418 0.841887 26.1314 0.400059 25.8C-0.0417689 25.4686 -0.131312 24.8418 0.200059 24.4C0.991809 23.3443 2.01847 22.4875 3.19874 21.8974C4.37901 21.3072 5.68042 21 7 21C8.31958 21 9.6211 21.3072 10.8014 21.8974C11.9816 22.4875 13.0083 23.3443 13.8001 24.4C14.1314 24.8418 14.0419 25.4686 13.6001 25.8C13.1582 26.1314 12.5314 26.0418 12.2001 25.6C11.5946 24.7927 10.8095 24.1375 9.90695 23.6862C9.00439 23.2349 8.00909 23 7 23Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7 2C5.34315 2 4 3.34315 4 5C4 6.65685 5.34315 8 7 8C8.65685 8 10 6.65685 10 5C10 3.34315 8.65685 2 7 2ZM2 5C2 2.23858 4.23858 0 7 0C9.76142 0 12 2.23858 12 5C12 7.76142 9.76142 10 7 10C4.23858 10 2 7.76142 2 5Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M7 10C5.99091 10 4.99573 10.2349 4.09317 10.6862C3.19061 11.1375 2.40551 11.7927 1.80006 12.6C1.46869 13.0418 0.841887 13.1314 0.400059 12.8C-0.0417689 12.4686 -0.131312 11.8418 0.200059 11.4C0.991809 10.3443 2.01847 9.4875 3.19874 8.89737C4.37901 8.30723 5.68042 8 7 8C8.31958 8 9.6211 8.30723 10.8014 8.89737C11.9816 9.4875 13.0083 10.3443 13.8001 11.4C14.1314 11.8418 14.0419 12.4686 13.6001 12.8C13.1582 13.1314 12.5314 13.0418 12.2001 12.6C11.5946 11.7927 10.8095 11.1375 9.90695 10.6862C9.00439 10.2349 8.00909 10 7 10Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19 15C17.3431 15 16 16.3431 16 18C16 19.6569 17.3431 21 19 21C20.6569 21 22 19.6569 22 18C22 16.3431 20.6569 15 19 15ZM14 18C14 15.2386 16.2386 13 19 13C21.7614 13 24 15.2386 24 18C24 20.7614 21.7614 23 19 23C16.2386 23 14 20.7614 14 18Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19 23C17.9909 23 16.9957 23.2349 16.0932 23.6862C15.1906 24.1375 14.4055 24.7927 13.8001 25.6C13.4687 26.0418 12.8419 26.1314 12.4001 25.8C11.9582 25.4686 11.8687 24.8418 12.2001 24.4C12.9918 23.3443 14.0185 22.4875 15.1987 21.8974C16.379 21.3072 17.6804 21 19 21C20.3196 21 21.6211 21.3072 22.8014 21.8974C23.9816 22.4875 25.0083 23.3443 25.8001 24.4C26.1314 24.8418 26.0419 25.4686 25.6001 25.8C25.1582 26.1314 24.5314 26.0418 24.2001 25.6C23.5946 24.7927 22.8095 24.1375 21.9069 23.6862C21.0044 23.2349 20.0091 23 19 23Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19 2C17.3431 2 16 3.34315 16 5C16 6.65685 17.3431 8 19 8C20.6569 8 22 6.65685 22 5C22 3.34315 20.6569 2 19 2ZM14 5C14 2.23858 16.2386 0 19 0C21.7614 0 24 2.23858 24 5C24 7.76142 21.7614 10 19 10C16.2386 10 14 7.76142 14 5Z'
      fill='#474747'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M19 10C17.9909 10 16.9957 10.2349 16.0932 10.6862C15.1906 11.1375 14.4055 11.7927 13.8001 12.6C13.4687 13.0418 12.8419 13.1314 12.4001 12.8C11.9582 12.4686 11.8687 11.8418 12.2001 11.4C12.9918 10.3443 14.0185 9.4875 15.1987 8.89737C16.379 8.30723 17.6804 8 19 8C20.3196 8 21.6211 8.30723 22.8014 8.89737C23.9816 9.4875 25.0083 10.3443 25.8001 11.4C26.1314 11.8418 26.0419 12.4686 25.6001 12.8C25.1582 13.1314 24.5314 13.0418 24.2001 12.6C23.5946 11.7927 22.8095 11.1375 21.9069 10.6862C21.0044 10.2349 20.0091 10 19 10Z'
      fill='#474747'
    />
  </svg>
);

export const queues = (
  <svg
    width='267'
    height='261'
    viewBox='0 0 267 261'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='queue'
  >
    <path
      d='M116 161.667C113.054 161.667 110.667 164.054 110.667 167C110.667 169.946 113.054 172.333 116 172.333C118.946 172.333 121.333 169.946 121.333 167C121.333 164.054 118.946 161.667 116 161.667ZM115 0L115 167H117L117 0L115 0Z'
      fill='#EC5C34'
    />
    <rect
      x='-0.0910168'
      y='176.562'
      width='260.194'
      height='84.6194'
      rx='7.5'
      transform='rotate(-5.32404 -0.0910168 176.562)'
      stroke='#EC5C34'
    />
    <path
      d='M42.408 232.463C39.8271 232.703 37.3785 232.465 35.0621 231.749C32.7776 231.03 30.7138 229.92 28.8707 228.421C27.0596 226.918 25.5722 225.097 24.4086 222.955C23.2768 220.811 22.5877 218.417 22.3414 215.772C22.095 213.127 22.33 210.647 23.0462 208.331C23.7914 205.979 24.9167 203.914 26.4221 202.135C27.9246 200.324 29.7495 198.868 31.8967 197.768C34.041 196.636 36.4035 195.95 38.9844 195.71C41.597 195.467 44.0457 195.704 46.3302 196.424C48.6437 197.108 50.706 198.201 52.5171 199.704C54.3602 201.203 55.8476 203.025 56.9793 205.17C58.1111 207.314 58.8001 209.708 59.0465 212.353C59.2928 214.997 59.042 217.479 58.2939 219.799C57.5776 222.115 56.4683 224.179 54.9658 225.99C53.4633 227.801 51.6399 229.273 49.4956 230.405C47.3514 231.536 44.9888 232.222 42.408 232.463ZM41.9272 227.301C43.7752 227.129 45.4327 226.637 46.8997 225.826C48.3986 225.011 49.6667 223.961 50.7039 222.675C51.7382 221.358 52.4997 219.873 52.9886 218.22C53.4744 216.536 53.6298 214.754 53.4547 212.874C53.2796 210.994 52.7992 209.287 52.0136 207.753C51.2279 206.22 50.2052 204.901 48.9454 203.797C47.6855 202.693 46.2439 201.879 44.6203 201.356C43.0286 200.829 41.3087 200.652 39.4607 200.824C37.6127 200.996 35.9393 201.489 34.4404 202.304C32.9733 203.115 31.7227 204.18 30.6884 205.498C29.6542 206.815 28.8926 208.3 28.4038 209.953C27.9468 211.602 27.8059 213.367 27.981 215.247C28.1561 217.127 28.622 218.851 29.3788 220.419C30.1644 221.953 31.1871 223.272 32.447 224.376C33.7038 225.448 35.144 226.246 36.7676 226.769C38.3912 227.293 40.111 227.47 41.9272 227.301ZM51.6925 235.358L38.3036 217.901L44.3256 217.34L57.7623 234.793L51.6925 235.358ZM75.7642 229.356C73.8206 229.537 72.0759 229.265 70.5301 228.542C68.9814 227.786 67.7201 226.666 66.7462 225.182C65.8013 223.663 65.2323 221.868 65.0394 219.797L63.5524 203.834L68.953 203.331L70.3955 218.816C70.5053 219.995 70.8407 221.008 71.4018 221.856C71.9628 222.703 72.6972 223.342 73.605 223.772C74.5098 224.17 75.5198 224.317 76.6349 224.213C77.782 224.106 78.7619 223.757 79.5747 223.167C80.3875 222.578 80.9898 221.798 81.3816 220.83C81.8054 219.858 81.9593 218.751 81.8436 217.509L80.4234 202.263L85.7762 201.764L88.1848 227.62L83.0709 228.096L82.599 223.03L83.2348 223.646C82.7779 225.296 81.8885 226.616 80.5667 227.607C79.2449 228.597 77.6441 229.18 75.7642 229.356ZM106.683 226.475C104.103 226.716 101.754 226.34 99.6364 225.348C97.5482 224.321 95.8515 222.84 94.5464 220.905C93.2383 218.938 92.4655 216.68 92.2281 214.131C91.9847 211.518 92.3271 209.156 93.2553 207.045C94.2153 204.931 95.5978 203.211 97.4027 201.886C99.2046 200.529 101.316 199.738 103.738 199.512C105.681 199.331 107.449 199.504 109.041 200.031C110.632 200.557 112.009 201.361 113.17 202.442C114.328 203.491 115.248 204.739 115.929 206.186C116.642 207.63 117.078 209.197 117.235 210.886C117.273 211.3 117.298 211.731 117.307 212.18C117.317 212.629 117.292 213.05 117.232 213.441L96.633 215.36L96.2323 211.058L113.772 209.424L111.374 211.624C111.547 210.033 111.307 208.658 110.652 207.497C110.027 206.302 109.14 205.405 107.991 204.805C106.871 204.17 105.595 203.919 104.161 204.053C102.727 204.186 101.487 204.671 100.44 205.508C99.3898 206.313 98.6245 207.413 98.1438 208.807C97.6601 210.17 97.5695 211.785 97.8721 213.653C97.876 215.421 98.2575 216.928 99.0164 218.175C99.8072 219.419 100.826 220.352 102.073 220.975C103.352 221.595 104.757 221.834 106.286 221.692C107.847 221.546 109.137 221.073 110.155 220.271C111.205 219.466 111.996 218.476 112.53 217.302L117.127 219.043C116.73 220.301 116.036 221.474 115.045 222.563C114.082 223.617 112.879 224.5 111.435 225.213C110.02 225.891 108.436 226.312 106.683 226.475ZM133.079 224.017C131.135 224.198 129.39 223.926 127.844 223.203C126.296 222.447 125.034 221.327 124.061 219.843C123.116 218.324 122.547 216.529 122.354 214.458L120.867 198.495L126.267 197.992L127.71 213.477C127.82 214.656 128.155 215.669 128.716 216.517C129.277 217.365 130.012 218.003 130.919 218.433C131.824 218.831 132.834 218.978 133.949 218.874C135.096 218.767 136.076 218.418 136.889 217.829C137.702 217.239 138.304 216.459 138.696 215.491C139.12 214.519 139.274 213.412 139.158 212.17L137.738 196.924L143.091 196.425L145.499 222.281L140.385 222.757L139.913 217.691L140.549 218.307C140.092 219.957 139.203 221.277 137.881 222.268C136.559 223.259 134.958 223.842 133.079 224.017ZM163.998 221.136C161.417 221.377 159.068 221.001 156.951 220.009C154.863 218.982 153.166 217.501 151.861 215.566C150.553 213.599 149.78 211.341 149.542 208.792C149.299 206.179 149.641 203.817 150.57 201.706C151.53 199.592 152.912 197.872 154.717 196.547C156.519 195.19 158.631 194.399 161.052 194.173C162.996 193.992 164.763 194.165 166.355 194.692C167.947 195.218 169.323 196.022 170.485 197.103C171.643 198.152 172.563 199.4 173.244 200.847C173.957 202.291 174.392 203.858 174.549 205.547C174.588 205.961 174.612 206.392 174.622 206.841C174.631 207.29 174.606 207.711 174.546 208.102L153.947 210.021L153.547 205.719L171.087 204.085L168.688 206.285C168.862 204.694 168.621 203.319 167.967 202.158C167.341 200.963 166.454 200.066 165.305 199.466C164.186 198.831 162.909 198.58 161.475 198.714C160.041 198.847 158.801 199.332 157.754 200.169C156.704 200.974 155.939 202.074 155.458 203.468C154.974 204.831 154.884 206.446 155.186 208.314C155.19 210.082 155.572 211.589 156.331 212.836C157.122 214.08 158.141 215.013 159.388 215.636C160.667 216.256 162.071 216.495 163.6 216.353C165.162 216.207 166.451 215.734 167.469 214.932C168.519 214.127 169.311 213.137 169.844 211.963L174.441 213.704C174.044 214.962 173.35 216.135 172.359 217.224C171.396 218.278 170.193 219.161 168.749 219.874C167.334 220.552 165.75 220.973 163.998 221.136ZM190.727 218.646C188.083 218.893 185.696 218.456 183.567 217.337C181.47 216.215 179.921 214.591 178.919 212.467L182.895 210.12C183.732 211.521 184.797 212.594 186.087 213.342C187.41 214.087 188.82 214.389 190.318 214.25C191.592 214.131 192.601 213.748 193.344 213.1C194.087 212.452 194.413 211.634 194.321 210.647C194.262 210.009 194.039 209.516 193.653 209.166C193.264 208.785 192.786 208.492 192.221 208.287C191.688 208.08 191.144 207.938 190.591 207.861L186.421 207.092C184.132 206.663 182.37 205.863 181.136 204.692C179.931 203.487 179.248 202.024 179.088 200.303C178.943 198.742 179.215 197.351 179.904 196.129C180.591 194.876 181.606 193.866 182.948 193.098C184.291 192.33 185.838 191.865 187.591 191.701C189.949 191.482 192.106 191.875 194.064 192.882C196.019 193.857 197.475 195.344 198.433 197.344L194.457 199.691C193.832 198.496 192.927 197.584 191.744 196.955C190.592 196.323 189.332 196.071 187.961 196.198C186.783 196.308 185.869 196.682 185.222 197.321C184.571 197.928 184.288 198.678 184.371 199.57C184.427 200.175 184.634 200.67 184.991 201.055C185.345 201.407 185.789 201.687 186.323 201.895C186.853 202.07 187.397 202.213 187.953 202.321L192.275 203.172C194.466 203.579 196.196 204.382 197.465 205.581C198.73 206.749 199.446 208.225 199.613 210.009C199.755 211.539 199.467 212.931 198.748 214.187C198.059 215.409 197.028 216.42 195.657 217.223C194.282 217.994 192.639 218.468 190.727 218.646Z'
      fill='#EC5C34'
    />
    <path
      d='M214 192.068L224.184 194.93L215.03 199.896'
      stroke='#316E4D'
      stroke-width='2'
    />
    <path
      d='M243.088 188.368L233.991 193.767L244.118 196.193'
      stroke='#316E4D'
      stroke-width='2'
    />
    <path
      d='M217.807 218.067C217.807 218.067 224.73 206.858 230.911 205.726C238.006 204.427 248.336 214.049 248.336 214.049'
      stroke='#316E4D'
      stroke-width='2'
    />
  </svg>
);

export const bike1 = (
  <svg
    width='398'
    height='629'
    viewBox='0 0 398 629'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M285.989 5.48702C269.093 19.6888 277.112 20.9379 286.129 12.4907C301.001 -1.45234 315.402 1.23602 317.616 18.4191C319.172 30.5961 307.849 51.6866 292.302 65.5466C276.082 80.0005 243.537 96.846 219.124 103.149C216.764 103.747 195.186 109.975 191.393 110.999C175.495 115.251 167.475 118.789 162.934 123.707C156.814 130.354 160.329 142.813 169.043 145.363C172.91 146.504 173.313 145.793 170.151 143.534C157.163 134.244 168.188 120.378 193.445 114.242C206.208 111.149 215.63 107.962 222.475 106.287C283.862 91.2825 336.263 40.8232 321.119 11.0174C315.431 -0.21898 296.355 -3.21729 285.989 5.48702Z'
      fill='#316E4D'
    />
    <path
      d='M233.138 105.891C235.793 97.6143 243.476 92 252.168 92C269.556 92 296.444 92 297.574 92H453.091C455.25 92 457 95.5818 457 100V602C457 606.418 455.25 610 453.091 610H214.466C212.528 610 139.757 605.806 99.7429 603.491C86.6919 602.736 77.8913 589.869 81.8843 577.421L233.138 105.891Z'
      fill='url(#paint0_linear_458_106)'
    />
    <g filter='url(#filter0_f_458_106)'>
      <path
        d='M166.86 502.2C135.859 503.413 74 516.583 74 516.583C74 516.583 138.852 522.477 171.834 523.775C216.834 525.546 300.511 511.8 300.511 511.8C300.511 511.8 213.769 500.363 166.86 502.2Z'
        fill='#E3996F'
      />
      <path
        d='M398.967 502.32C367.878 503.527 280.915 512.183 280.915 512.183C280.915 512.183 370.88 522.485 403.956 523.776C449.084 525.537 533 511.867 533 511.867C522.244 511.53 428.528 499.946 398.967 502.32Z'
        fill='#E3996F'
      />
    </g>
    <path
      d='M317.872 308.876C387.354 226.577 437.948 325.741 366.122 334.367C284.142 334.367 309.777 433 402.869 356.097'
      stroke='#EF6517'
      stroke-width='7'
      stroke-linecap='round'
    />
    <path
      d='M320.571 306.853C379.934 254.91 432.871 328.948 361.046 337.575C294.262 337.575 336.081 415.461 404.219 356.097'
      stroke='#EF6517'
      stroke-width='7'
      stroke-linecap='round'
    />
    <path
      d='M129.048 461.344C125.788 459.651 123.147 455.408 122.43 445.942C123.936 441.252 126.705 438.376 130.265 437.108C133.712 435.879 138.364 435.995 144.107 438.185L144.675 460.365C137.32 462.853 132.304 463.036 129.048 461.344Z'
      stroke='#444741'
      stroke-width='6'
    />
    <path
      d='M157.013 458.858C154.56 463.832 149.098 468.292 137.396 472.192C130.231 470.855 124.242 468.357 120.4 463.892C116.605 459.482 114.44 452.598 116.166 441.434C123.459 432.146 130.632 428.33 137.252 428.19C143.872 428.051 150.827 431.565 157.753 438.902C159.296 447.552 159.491 453.832 157.013 458.858Z'
      stroke='#31332E'
      stroke-width='6'
    />
    <path
      d='M172.756 493.136L172.533 493.378L172.347 493.65C172.378 493.604 172.361 493.62 172.281 493.695C172.089 493.877 171.533 494.401 170.404 495.24C168.995 496.289 167.019 497.589 164.568 498.95C159.66 501.677 153 504.564 145.349 506.211C130.197 509.471 111.171 507.909 93.5723 490.31L93.5209 490.259L93.468 490.209C80.5855 478.132 68.5164 446.271 91.2853 413.231C105.324 396.199 120.487 390.274 133.582 389.477C146.889 388.668 158.399 393.142 164.773 397.384L176.807 405.617C177.05 405.991 177.322 406.405 177.621 406.858C181.092 412.124 187.992 422.592 190.883 436.4C194.147 451.997 192.275 472.018 172.756 493.136Z'
      stroke='black'
      stroke-width='9'
    />
    <path
      d='M393.953 490.794L335.939 453.692C321.323 448.97 323.256 425.629 447.92 370.044C572.583 314.458 517.402 360.375 474.228 390.281L398.802 484.723L393.953 490.794Z'
      fill='#444746'
    />
    <path
      d='M95.2321 428.55L95.1399 428.705L95.067 428.87C89.737 440.95 88.797 454.049 92.9542 465.978C97.1211 477.936 106.319 488.46 120.782 495.514L121.064 495.652L121.369 495.728C138.312 499.964 152.154 496.934 162.37 489.09C172.501 481.311 178.695 469.084 181.043 455.554C182.352 448.014 182.71 441.599 181.223 435.259C179.733 428.905 176.458 422.912 170.987 416.066L170.838 415.88L170.661 415.719L163.241 408.973L162.934 408.695L162.564 408.51C147.149 400.802 133.632 399.938 122.156 404.161C110.761 408.355 101.859 417.388 95.2321 428.55Z'
      stroke='#92938E'
      stroke-width='6'
    />
    <path
      d='M269.155 295.165C267.683 292.938 266.966 294.017 265.782 294.49C264.253 295.664 263.206 296.942 263.084 299.887C262.585 302.36 265.818 300.963 268.481 299.887C269.921 297.728 269.423 296.881 269.155 295.165Z'
      fill='#ABA09B'
    />
    <path
      d='M257.688 291.792C259.308 291.039 263.533 291.536 267.131 293.815C265.552 295.18 262.677 297.971 263.083 301.236C259.261 299.897 258.123 298.452 255.663 297.188C252.388 295.384 252.025 293.612 257.688 291.792Z'
      fill='#D0CDC5'
    />
    <path
      d='M314.352 307.307V301.911L331.891 298.538C337.033 293.978 339.805 290.143 342.685 287.07C348.39 288.953 352.881 292.326 353.478 291.792C356.287 284.245 358.117 280.12 361.573 276.276L357.526 323.497C342.924 310.537 332.458 306.23 314.352 307.307Z'
      fill='#313C43'
    />
    <path
      d='M142.335 446.272L176.063 384.21L184.158 390.281L149.081 451.668C146.702 454.51 145.312 456.292 142.335 461.113L134.914 456.39C129.167 451.81 129.977 449.585 142.335 446.272Z'
      fill='#777970'
    />
    <path
      d='M244.716 198.025C241.38 205.912 240.225 211.364 240.062 223.845C241.357 239.64 239.712 251.837 237.402 251.061C236.997 262.105 235.485 269.753 234.077 271.298C236.909 276.817 238.688 278.236 242.057 278.975C243.957 278.271 242.057 278.975 242.057 274.788C241.311 266.002 241.536 259.257 242.057 248.27C242.181 234.783 242.357 227.361 250.036 223.845C251.07 210.019 248.506 199.872 244.716 198.025Z'
      fill='url(#paint1_linear_458_106)'
    />
    <path
      d='M213.839 303.26C213.839 303.26 218.561 305.958 220.585 305.283C225.004 306.921 231.379 310.68 231.379 310.68L230.029 312.029L234.751 315.402L230.029 314.053L231.379 316.751L228.006 320.124C228.006 320.124 225.623 323.883 223.958 326.196C215.189 323.497 195.626 346.433 191.578 355.203C190.902 358.57 190.903 363.972 190.903 363.972C190.903 363.972 174.04 366.671 159.198 354.528C174.714 330.243 182.809 318.101 207.093 303.26C209.45 302.082 213.839 303.26 213.839 303.26Z'
      fill='#171C1F'
    />
    <path
      d='M194.951 341.711C196.3 341.037 194.276 345.759 194.276 345.759L189.554 353.179C189.554 353.179 190.903 359.25 186.856 361.274C184.832 360.599 170.665 358.576 165.269 353.179C166.618 344.41 188.205 341.711 194.951 341.711Z'
      fill='#D0E0D2'
    />
    <path
      d='M238.124 314.053C238.124 314.053 217.212 301.911 213.839 299.212C221.934 296.514 238.124 283.022 238.124 283.022C238.124 283.022 252.29 299.887 252.29 302.585C246.894 302.585 245.545 305.283 245.545 305.283L238.124 314.053Z'
      fill='url(#paint2_linear_458_106)'
    />
    <path
      d='M211.141 264.808L218.561 274.253L198.323 297.863C197.081 285.617 201.109 277.842 211.141 264.808Z'
      fill='#D0E0D2'
    />
    <path
      d='M213.164 268.181L218.561 274.253C218.561 274.253 211.14 285.72 205.743 289.093C202.371 278.3 213.164 268.181 213.164 268.181Z'
      fill='#EEF5FA'
    />
    <path
      d='M218.562 274.927L198.999 297.863C198.999 297.863 219.911 300.562 229.355 296.514C233.403 294.779 231.454 292.143 233.403 289.768C238.045 284.109 256.818 281.496 249.593 280.324C247.772 280.029 244.871 280.324 244.871 280.324L237.45 274.927H218.562Z'
      fill='#232825'
    />
    <path
      d='M211.142 264.808C209.992 263.084 228.682 262.785 228.682 262.785L238.125 274.927H232.054H219.238C219.238 274.927 217.888 274.927 211.142 264.808Z'
      fill='#232825'
    />
    <path
      d='M159.874 356.552L168.643 358.576C166.701 358.587 164.71 358.708 162.686 358.922L219.912 407.146L222.61 426.034C216.829 436.937 212.207 446.739 217.888 455.716H340.662V469.208L329.869 473.93H316.377L307.608 479.326L276.577 473.93L268.482 471.906L264.434 473.93L248.244 469.208L222.61 467.184C209.578 465.873 204.289 463.172 201.698 451.668C197.041 445.931 195.955 441.905 196.301 433.455C195.248 408.102 188.639 398.707 170.667 386.908C151.215 376.41 106.581 385.145 105.232 382.861C103.979 380.738 136.115 361.733 162.686 358.922L159.874 356.552Z'
      fill='#151B18'
    />
    <path
      d='M192.252 361.274C180.708 362.451 170.671 362.053 158.523 355.203L178.086 375.44L202.371 392.979L192.252 361.274Z'
      fill='#171C1F'
    />
    <path
      d='M161.738 439.707C158.952 437.518 157.854 438.895 157.854 438.895C155.719 440.054 153.78 442.861 153.458 444.4C155.467 446.427 153.724 450.881 152.17 450.556C150.616 450.231 145.121 457.113 147.585 460.841C149.556 463.823 147.655 465.674 146.458 466.227C145.261 466.78 150.637 469.51 154.228 467.852C161.785 458.38 162.886 453.601 161.738 439.707Z'
      fill='black'
    />
    <path
      d='M135.586 404.447H140.308V424.685H133.562L135.586 404.447Z'
      fill='#151D1F'
    />
    <path
      d='M95.4834 436.656L96.6267 432.075L114 436.827L112.102 442.889L95.4834 436.656Z'
      fill='#151D1F'
    />
    <path
      d='M111.975 487.421L108.78 484.723L117.531 468.333L122.454 470.976L111.975 487.421Z'
      fill='#151D1F'
    />
    <path
      d='M163.597 482.413L162.278 484.468L148.722 470.382L153.05 466.843L163.597 482.413Z'
      fill='#151D1F'
    />
    <path
      d='M177.41 431.431L178.843 435.407L160.295 441.585L158.963 436.155L177.41 431.431Z'
      fill='#151D1F'
    />
    <path
      d='M150.355 426.658L159.37 410.56L160.563 411.355L151.45 428.013L150.355 426.658Z'
      stroke='#151D1F'
    />
    <path
      d='M410.144 264.809L375.066 256.714V329.569L413.517 343.06L410.144 264.809Z'
      fill='#BE3F1C'
    />
    <path
      d='M449.945 244.571L379.113 258.737L411.493 265.483L483.674 250.642L449.945 244.571Z'
      fill='#EF8669'
    />
    <path
      d='M305.167 191.216C300.247 194.564 298.127 196.851 299.046 198.757C304.309 199.984 307.317 199.051 309.927 198.757C318.153 196.319 321.489 193.478 320.129 184.428C314.026 181.383 310.59 178.934 304.487 179.149L305.167 191.216Z'
      fill='#D8B69B'
    />
    <path
      d='M317.724 189.255C317.632 190.153 312.927 192.834 313.002 192.628C312.566 193.582 312.687 193.98 313.002 194.652C313.656 194.813 314.103 194.802 315.026 194.652C317.452 192.941 318.36 191.781 319.073 189.255C319.073 189.255 317.816 188.358 317.724 189.255Z'
      fill='#9C765A'
    />
    <path
      d='M304.909 183.858H312.329L319.75 187.906H310.306C308.754 187.456 308.145 187.362 304.909 185.882C304.483 184.904 304.519 184.468 304.909 183.858Z'
      stroke='#0C0D0D'
      stroke-width='0.5'
    />
    <path
      d='M305.583 191.279V186.557L310.305 188.581V193.977C308.281 195.326 305.583 193.303 305.583 191.279Z'
      stroke='#0C0D0D'
      stroke-width='0.5'
    />
    <path
      d='M304.909 184.533C304.747 185.218 304.896 185.61 305.583 185.882C308.893 185.49 312.329 185.208 313.678 185.208L311.655 183.858C305.976 184.384 305.072 183.458 304.909 184.533Z'
      fill='#1B1B1B'
    />
    <path
      d='M319.749 187.231C314.522 186.157 310.666 185.154 310.305 182.509C310.786 181.422 311.069 181.028 311.654 181.16C314.29 181.243 315.778 181.77 318.4 183.858C321.098 183.184 321.773 187.906 319.749 187.231Z'
      fill='#2A2E31'
    />
    <path
      d='M308.43 197.355C308.444 197.901 307.247 198.373 305.757 198.409C304.267 198.445 303.049 198.032 303.036 197.487C302.738 196.806 303.903 196.394 305.709 196.433C307.199 196.397 308.417 196.81 308.43 197.355Z'
      fill='#231816'
    />
    <path
      d='M363.597 196.675C364.946 189.255 372.366 174.414 360.898 158.224C353.414 153.223 348.741 151.207 339.312 149.454C330.288 148.355 325.015 149.082 315.027 153.502L320.423 186.557L319.749 191.279C313.003 201.397 297.487 196.675 297.487 196.675C297.487 196.675 286.694 208.818 303.559 221.635C308.955 217.587 313.003 217.587 313.003 217.587C313.003 217.587 321.098 220.96 327.844 217.587C329.867 214.215 358.875 193.977 363.597 196.675Z'
      fill='#2A3234'
    />
    <path
      d='M309.631 151.478C303.37 151.694 292.307 158.016 288.718 167.668C297.488 177.787 321.098 184.533 321.098 184.533C333.196 186.039 336.144 183.26 337.289 174.414C337.289 174.414 324.471 157.55 309.631 151.478Z'
      fill='url(#paint3_linear_458_106)'
    />
    <path
      d='M332 154.177C328.046 155.104 323.905 156.875 323.23 157.55C322.556 158.224 325.254 158.899 325.254 158.899C325.254 158.899 336.722 153.502 336.047 153.502C335.373 153.502 332 154.177 332 154.177Z'
      fill='#778997'
    />
    <path
      d='M338.637 159.196C334.456 160.383 333.401 161.892 332.566 165.267C338.098 167.245 341.2 166.602 346.732 165.267C352.149 167.968 354.087 173.398 356.851 177.41C356.705 173.152 357.005 167.903 359.55 167.291C359.469 162.993 358.539 161.698 354.827 161.894C351.749 162.306 350.004 162.332 346.732 160.545C343.867 159.029 342.159 158.511 338.637 159.196Z'
      fill='url(#paint4_linear_458_106)'
    />
    <path
      d='M323.122 219.611L342.047 206.169C343.278 209.836 344.791 211.099 348.756 212.191L329.868 227.706C328.598 222.851 329.127 221.862 323.122 219.611Z'
      fill='url(#paint5_linear_458_106)'
    />
    <path
      d='M348.756 212.191C348.756 212.191 350.78 211.516 359.549 214.214C368.993 215.564 379.678 246.594 380.461 247.944C381.681 292.919 375.408 296.761 380.461 337.664L356.176 324.846L361.573 276.276L352.803 292.466L322.447 278.975L308.281 280.324L304.233 276.276C315.3 258.126 318.598 246.399 326.495 225.683C329.042 225.32 329.63 225.907 329.868 227.706C335.382 221.222 342.702 216.845 348.756 212.191Z'
      fill='#3B4850'
    />
    <path
      d='M288.043 283.022C293.595 279.966 296.704 278.233 302.884 276.951L308.281 280.998C300.839 282.931 296.362 283.261 288.043 283.022Z'
      fill='#D7B59B'
    />
    <path
      d='M249.592 416.59C248.729 411.92 250.267 404.447 250.267 404.447L253.639 403.773L261.735 421.312H250.941C250.941 421.312 249.941 418.476 249.592 416.59Z'
      fill='#161C18'
    />
    <path
      d='M242.171 319.45C261.355 314.714 274.353 315.066 296.813 314.728L250.267 408.495C252.965 419.288 236.695 368.695 234.076 357.227C234.183 338.408 229.624 321.34 242.171 319.45Z'
      fill='#534739'
    />
    <path
      d='M302.209 391.63C297.699 377.825 293.566 368.795 289.392 363.298C321.174 365.915 339.572 361.928 371.017 350.481C373.249 341.267 375.937 340.185 382.485 334.965C393.222 340.985 394.65 340.284 392.604 334.965L419.587 345.084L431.055 347.108L472.879 378.139C416.889 384.21 355.501 426.709 342.684 458.414L218.561 456.39C210.773 448.053 210.924 439.906 221.934 424.685V408.495L213.164 362.623C219.168 338.023 224.845 328.662 237.449 316.751L233.402 353.854L227.33 359.25C224.674 378.018 227.576 395.156 233.402 426.709C242.156 427.352 246.225 425.89 252.29 420.637H288.718C291.881 407.773 294.572 401.223 302.209 391.63Z'
      fill='#232825'
    />
    <path
      d='M330.542 436.153C366.728 405.405 406.861 386.475 418.238 392.305C382.405 413.24 368.44 422.008 355.502 436.153H330.542Z'
      fill='#B3BCBA'
    />
    <path
      d='M383.834 405.796C375.543 409.773 371.265 411.998 367.644 415.915C366.666 418.88 367.251 419.926 371.692 419.963C377.425 416.066 381.667 415.552 387.881 409.169C388.474 406.05 385.946 404.889 383.834 405.796Z'
      fill='#B0480B'
    />
    <path
      d='M387.882 399.051C399.097 394.645 406.479 392.832 416.214 392.305C417.478 392.538 409.962 395.87 400.699 401.075C402.243 397.099 399.068 396.835 387.882 399.051Z'
      fill='#767F7C'
    />
    <path
      d='M420.013 372.641C418.449 372.688 416.926 372.923 415.386 373.162C414.014 373.374 412.444 373.89 411.06 373.89C408.936 373.89 407.254 374.761 405.241 375.348C402.705 376.088 399.616 377.342 397.989 379.512C397.37 380.337 396.723 381.227 395.861 381.802'
      stroke='#5B6762'
      stroke-linecap='round'
    />
    <path
      d='M405.421 362.623C362.153 373.076 341.675 384.342 312.328 411.193'
      stroke='#5E6964'
    />
    <path
      d='M344.595 378.139L344.708 378.139L314.351 405.797C313.677 403.098 321.976 390.923 326.494 384.884C331.468 378.236 340.526 378.169 344.595 378.139Z'
      fill='url(#paint6_linear_458_106)'
    />
    <path
      d='M391.928 370.718H404.071L389.23 376.115C362.219 388.155 347.696 398.296 322.446 419.963C314.525 424.472 311.385 429.007 306.931 438.851C306.284 434.483 305.517 432.596 306.931 425.359C329.802 400.18 345.984 387.311 391.928 370.718Z'
      fill='url(#paint7_linear_458_106)'
    />
    <path
      d='M309.63 314.728L313.003 307.982C347.165 302.937 358.818 328.51 378.438 336.314C379.512 341.593 375.916 346.685 367.645 354.528C329.007 367.122 308.522 369.254 275.227 359.25C280.669 402.792 286.291 416.95 290.068 428.058C282.834 438.895 277.747 437.953 266.457 433.455C245.193 391.336 233.7 362.692 239.474 330.918C242.318 322.944 258.343 319.444 309.63 314.728Z'
      fill='#826545'
    />
    <path
      d='M265.782 348.457C270.021 356.598 276.178 359.228 275.901 361.949'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M261.06 342.386C261.06 342.386 275.743 348.98 275.901 355.877'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M312.329 318.101L346.058 342.386L315.139 325.386'
      stroke='#52402C'
      stroke-width='0.5'
    />
    <path
      d='M306.932 325.268C310.456 327.417 311.798 326.621 316.622 332.86C316.622 332.86 322.172 336.926 323.453 340.325'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M309.63 315.402C316.71 313.157 324.471 316.751 330.542 322.823M299.511 334.29L308.281 342.385'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M290.528 335.64L301.391 347.376'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M304.233 331.592L312.328 339.013'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M257.687 455.716C254.989 456.391 240.235 455.282 234.076 446.946C234.076 446.946 286.694 432.78 288.718 436.153C290.742 439.526 292.77 446.06 290.742 450.994C282.181 455.127 260.385 455.041 257.687 455.716Z'
      fill='#CDDBE6'
    />
    <path
      d='M233.402 446.272C233.402 442.899 246.611 436.907 261.735 439.526L267.806 433.455L288.718 430.082C290.7 436.606 291.77 440.742 288.718 446.272C276.151 450.775 258.362 453.018 258.362 453.018C258.362 453.018 233.403 449.645 233.402 446.272Z'
      fill='black'
    />
    <path
      d='M345.383 481.35C344.621 475.273 342.653 473.394 337.288 471.906V453.692C337.699 454.361 350.147 456.757 354.153 460.438C367.769 462.768 367.545 470.669 377.763 475.279L387.882 488.096H366.295C362.905 485.562 364.363 482.643 354.153 483.374C343.942 484.104 346.626 484.197 345.383 481.35Z'
      fill='#232825'
    />
    <path
      d='M336.38 313.867C333.902 309.959 332.858 309.944 331.326 311.859C333.174 314.685 333.788 316.4 334.468 319.589C335.461 319.947 336.077 320.245 337.424 321.213'
      stroke='#52402C'
      stroke-width='0.5'
    />
    <path
      d='M335.939 316.077L339.986 319.45'
      stroke='#52402C'
      stroke-width='0.2'
    />
    <path
      d='M247.568 282.348L244.87 290.443C245.857 293.379 247.594 295.569 251.616 299.887C255.011 301.456 256.197 301.236 257.687 299.887C259.177 298.538 253.64 295.165 253.64 295.165C257.242 290.404 260.884 290.608 269.83 295.165C270.946 295.379 271.647 295.532 275.901 297.188C296.712 301.155 312.106 303.222 331.891 298.538C336.023 295.128 338.249 293.052 341.336 287.744C335.559 284.811 331.316 282.996 323.122 279.649C318.18 280.483 315.747 280.824 308.956 282.348C300.637 283.839 295.709 283.012 286.694 283.697C279.412 284.049 274.692 285.263 265.782 285.046C258.655 283.206 254.66 282.539 247.568 282.348Z'
      fill='#F2D9C5'
    />
    <path
      d='M273.203 291.117C270.715 292.636 272.528 293.141 270.504 294.49C283.321 297.863 312.805 303.902 329.193 299.212L329.183 299.17C328.768 297.415 328.233 295.148 325.146 293.815C305.098 291.506 293.758 290.751 273.203 291.117Z'
      fill='url(#paint8_linear_458_106)'
    />
    <path
      d='M304.088 196.517C303.975 196.56 303.738 196.553 303.498 196.562C303.22 196.679 303.014 196.893 303.014 197.268C303.014 197.867 303.674 197.77 304.085 197.824C304.676 197.903 305.318 197.836 305.915 197.836H306.848C307.173 197.836 307.566 197.912 307.847 197.729C308.173 197.515 308.234 197.22 307.963 196.915C307.805 196.738 307.726 196.398 307.428 196.383C307.113 196.367 306.806 196.329 306.489 196.329C305.693 196.329 304.846 196.233 304.088 196.517Z'
      fill='#231816'
    />
    <path
      d='M412.902 408.924H454.239C470.063 418.439 478.239 428.817 482.336 439.204C486.53 449.836 486.744 461.205 485.4 473.09C478.839 490.746 468.799 500.348 456.982 504.869C444.907 509.488 430.012 509.174 413.253 504.945C406.206 500.97 400.868 497.24 396.442 492.517C392.115 487.9 388.405 482.056 385.008 473.555L386.913 439.892C389.295 431.226 392.7 425.852 396.916 421.491C400.698 417.579 405.12 414.444 410.765 410.441C411.459 409.95 412.171 409.445 412.902 408.924Z'
      stroke='black'
      stroke-width='13'
    />
    <path
      d='M437.801 502.786H437.783L437.764 502.786C419.739 503.231 399.643 495.041 392.24 474.794L431.271 413.933C453.733 411.026 478.537 429.589 479.475 456.416C479.462 484.639 459.17 502.786 437.801 502.786Z'
      stroke='#92938E'
      stroke-width='3'
    />
    <path
      d='M471.018 475.71L470.957 475.79L470.907 475.876C467.244 482.202 463.123 487.805 456.893 491.885C450.684 495.951 442.234 498.598 429.759 498.738C417.271 497.711 409.196 491.564 404.549 486.316C402.392 483.879 400.986 481.649 400.236 480.241L432.696 416.647C448.03 415.205 461.701 424.344 469.568 436.784C477.594 449.475 479.26 465.051 471.018 475.71Z'
      stroke='#272727'
      stroke-width='3'
    />
    <path
      d='M398.676 448.295L363.598 440.875V450.319L360.225 448.295C360.225 448.295 355.587 450.322 354.828 453.018C354.083 455.665 356.852 459.763 356.852 459.763C356.852 459.763 365.622 461.787 367.645 463.811C369.669 465.835 366.296 469.208 366.296 469.208C389.453 473.965 410.236 476.664 415.541 481.35C423.611 485.2 427.873 485.695 435.104 483.374H441.85C441.85 483.374 453.433 480.071 455.341 473.93C457.049 468.435 451.294 459.763 451.294 459.763C432.773 446.838 421.104 444.972 398.676 448.295Z'
      fill='url(#paint9_linear_458_106)'
    />
    <path
      d='M414.191 461.112C387.05 452.413 377.281 452.133 369.668 453.692L367.645 457.739C372.367 463.811 395.08 471.486 412.167 471.906L414.191 461.112Z'
      fill='url(#paint10_linear_458_106)'
    />
    <path
      d='M431.055 430.756C429.044 422.579 429.032 418.737 433.079 414.566L435.778 403.773H412.167C390.004 411.888 385.037 423.097 381.136 442.224L400.699 446.272C422.138 442.177 433.592 445.833 453.317 459.763L450.618 446.272L441.174 440.2C441.174 440.2 437.62 438.97 435.778 437.502C435.636 435.097 435.354 433.722 431.055 430.756Z'
      fill='#171C1F'
    />
    <path
      d='M190.229 359.681C194.276 344.409 223.556 316.716 230.029 323.497C225.207 329.668 212.232 359.681 212.232 359.681L222.566 416.59H212.232C212.232 416.59 194.362 381.622 190.229 359.681Z'
      fill='#A6B4B2'
    />
    <circle cx='362.248' cy='455.716' r='2.69834' fill='#222625' />
    <circle cx='375.065' cy='457.74' r='3.37292' fill='#222625' />
    <path
      d='M256.375 294.697C256.497 294.33 258.768 294.553 259.118 294.553C259.999 294.553 260.656 294.767 261.448 295.133C261.775 295.283 262.095 295.364 262.384 295.556C262.602 295.702 262.947 295.992 263.211 295.992'
      stroke='#ABA09B'
      stroke-width='0.5'
      stroke-linecap='round'
    />
    <path
      d='M131.748 570.848C145.863 574.301 106.548 592.536 93.2001 598.16C68.3299 608.674 74.1155 609.49 83.2415 605.765C86.4984 604.446 96.0833 600.667 104.487 597.391C130.042 587.418 136.77 583.977 140.89 579.034C150.215 567.827 118.967 559.882 93.1054 566.836C58.8277 576.084 12.5421 600.948 2.78326 610.238C-1.90729 614.731 -0.81534 617.398 13.5682 609.165C65.318 579.353 108.793 565.234 131.748 570.848Z'
      fill='#FF8966'
    />
    <path
      d='M191.751 567.413C188.683 569.019 182.471 572.45 175.7 576.412C108.189 615.91 53.7084 634.909 54.8003 618.829C55.2721 611.472 72.4506 594.105 85.402 587.751C89.945 585.503 86.5709 584.091 82.5041 585.557C74.4214 588.484 57.9086 600.129 52.3394 607.677C44.997 617.714 47.8533 625.661 59.6052 627.943C72.8908 630.509 114.083 617.644 140.535 602.594C147.804 598.469 184.311 575.753 193.956 569.43C199.053 566.184 194.141 566.197 191.751 567.413Z'
      fill='#FF8966'
    />
    <defs>
      <filter
        id='filter0_f_458_106'
        x='64'
        y='492'
        width='479'
        height='41.9326'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='5'
          result='effect1_foregroundBlur_458_106'
        />
      </filter>
      <linearGradient
        id='paint0_linear_458_106'
        x1='231.932'
        y1='338'
        x2='661.481'
        y2='341.001'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#FFB58B' />
        <stop offset='1' stop-color='#FFCD87' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_458_106'
        x1='242.172'
        y1='198.025'
        x2='236.188'
        y2='301.972'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#171D1D' />
        <stop offset='1' stop-color='#484E53' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_458_106'
        x1='232.727'
        y1='297.863'
        x2='252.965'
        y2='314.053'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#1E2320' />
        <stop offset='1' stop-color='#6B6D6C' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_458_106'
        x1='292.091'
        y1='160.923'
        x2='326.495'
        y2='175.089'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#D0CFCE' />
        <stop offset='1' stop-color='#233237' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_458_106'
        x1='331.892'
        y1='165.942'
        x2='361.573'
        y2='166.617'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#778997' />
        <stop offset='1' stop-color='#DEE5EF' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_458_106'
        x1='335.939'
        y1='212.865'
        x2='338.637'
        y2='216.913'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#9B7659' />
        <stop offset='1' stop-color='#D7B59B' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_458_106'
        x1='329.51'
        y1='378.139'
        x2='329.51'
        y2='405.797'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#304244' />
        <stop offset='1' stop-color='#304244' stop-opacity='0' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_458_106'
        x1='389.905'
        y1='376.115'
        x2='320.423'
        y2='417.264'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#717B72' />
        <stop offset='1' stop-color='#2B3A3D' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_458_106'
        x1='329.868'
        y1='297.863'
        x2='272.528'
        y2='292.466'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#D5B398' />
        <stop offset='1' stop-color='#DDB79C' stop-opacity='0.41' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_458_106'
        x1='354.153'
        y1='454.367'
        x2='392.605'
        y2='459.763'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#86887A' />
        <stop offset='1' stop-color='#EAEBEA' />
      </linearGradient>
      <linearGradient
        id='paint10_linear_458_106'
        x1='404.072'
        y1='462.462'
        x2='367.645'
        y2='453.017'
        gradientUnits='userSpaceOnUse'
      >
        <stop stop-color='#C8C9C6' />
        <stop offset='1' stop-color='#F4F4F4' />
      </linearGradient>
    </defs>
  </svg>
);

export const white_dot = (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='white_dot'
  >
    <circle cx='7.5' cy='7.5' r='7.5' fill='#FFF4EF' />
  </svg>
);

export const thong = (
  <svg
    width='141'
    height='105'
    viewBox='0 0 141 105'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M115.719 10.0348C117.342 9.27636 119.01 10.9958 118.202 12.5951C118.044 12.9068 117.803 13.1686 117.506 13.3515L106.261 20.2657L48.3659 52.2773C47.322 52.8545 46.3898 53.6138 45.6133 54.5194L22.2217 81.8C19.7294 84.7067 15.2618 84.7958 12.6555 81.9908C10.1386 79.2819 10.4279 75.0115 13.2872 72.6669L54.2027 39.1158C54.8473 38.5872 55.5556 38.1413 56.3109 37.7884L115.719 10.0348Z'
      fill='#EC5C34'
    />
    <path
      d='M130.395 38.1946C131.894 37.402 131.501 35.1538 129.822 34.9162C129.52 34.8735 129.212 34.9105 128.928 35.0237L116.643 39.9286L56.3993 67.0425C55.3829 67.5 54.2971 67.7843 53.1868 67.8837L17.0052 71.1227C13.5145 71.4351 11.0314 74.6572 11.6186 78.1124C12.2082 81.582 15.6408 83.8039 19.0477 82.9211L70.3769 69.6206C71.1289 69.4257 71.8557 69.1439 72.5424 68.7808L130.395 38.1946Z'
      fill='#EC5C34'
    />
  </svg>
);

export const star = (
  <svg
    width='14'
    height='13'
    viewBox='0 0 14 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 0L8.5716 4.83688H13.6574L9.5429 7.82624L11.1145 12.6631L7 9.67376L2.8855 12.6631L4.4571 7.82624L0.342604 4.83688H5.4284L7 0Z'
      fill='white'
    />
  </svg>
);

export const plus_svg = (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.33333 11.6667V6.33333V11.6667ZM6.33333 6.33333V1V6.33333ZM6.33333 6.33333H11.6667H6.33333ZM6.33333 6.33333H1H6.33333Z'
      fill='#C5C5C5'
    />
    <path
      d='M6.33333 11.6667V6.33333M6.33333 6.33333V1M6.33333 6.33333H11.6667M6.33333 6.33333H1'
      stroke='#C5C5C5'
      stroke-width='2'
      stroke-linecap='round'
    />
  </svg>
);

export const minus_svg = (
  <svg
    width='13'
    height='2'
    viewBox='0 0 13 2'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M11.6667 1H1H11.6667Z' fill='#C5C5C5' />
    <path
      d='M11.6667 1H1'
      stroke='#C5C5C5'
      stroke-width='2'
      stroke-linecap='round'
    />
  </svg>
);

export const plus_svg2 = (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    className='plus_svg2'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7 13V7M7 7V1M7 7H13M7 7H1'
      // stroke='#EC5C34'
      stroke-width='2'
      stroke-linecap='round'
    />
  </svg>
);

export const Search_icon = (
  <svg
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23.6611 23.1231L18.4518 17.9607M21.3386 11.0615C21.3386 13.6511 20.2987 16.1347 18.4476 17.9658C16.5966 19.7969 14.086 20.8256 11.4681 20.8256C8.85033 20.8256 6.33973 19.7969 4.48866 17.9658C2.63758 16.1347 1.59766 13.6511 1.59766 11.0615C1.59766 8.47193 2.63758 5.98839 4.48866 4.15726C6.33973 2.32614 8.85033 1.29742 11.4681 1.29742C14.086 1.29742 16.5966 2.32614 18.4476 4.15726C20.2987 5.98839 21.3386 8.47193 21.3386 11.0615V11.0615Z'
      stroke='#7A7979'
      stroke-width='2'
      stroke-linecap='round'
    />
  </svg>
);

export const Menu_page_sub_nav_buttons_toggler = (
  <svg
    viewBox='64 64 896 896'
    focusable='false'
    data-icon='align-left'
    width='1em'
    height='1em'
    fill='currentColor'
    aria-hidden='true'
  >
    <path d='M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'></path>
  </svg>
);
